import React, { useState } from 'react';
import { Heart } from 'lucide-react';
import authService from '../services/AuthService';
import { API_BASE } from '../consts';

const UniversalFavoriteButton = ({ deal, onFavoriteChange }) => {
    const [isFavorited, setIsFavorited] = useState(!!deal.favorite);
    const [loading, setLoading] = useState(false);

    const identifier = deal.marketplace === 'amazon'
        ? deal?.marketplace_data?.asin
        : deal.marketplace === 'walmart'
            ? deal?.marketplace_data?.item_id
            : deal.marketplace === 'ebay'
                ? deal?.marketplace_data?.upc
                : '';

    const handleToggle = async (e) => {
        e.stopPropagation();
        setLoading(true);
        const newValue = !isFavorited;
        try {
            await authService.authenticatedFetch(
                `${API_BASE}/api/universal_live-scan/deals/${deal.id}/favorite`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ favorite: newValue })
                }
            );
            setIsFavorited(newValue);
            deal.favorite = newValue;
            if (onFavoriteChange) onFavoriteChange(newValue);
        } catch (err) {
            console.error('Failed to toggle universal favorite', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <button
                onClick={handleToggle}
                disabled={loading}
                className={`rounded-full transition-all ${isFavorited
                        ? 'text-red-500 hover:text-red-600 bg-red-50 hover:bg-red-100'
                        : 'text-gray-400 hover:text-red-500 hover:bg-red-50'
                    } ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                title={isFavorited ? 'Remove from favorites' : 'Add to favorites'}
            >
                <Heart
                    size={18}
                    fill={isFavorited ? 'currentColor' : 'none'}
                    className="transition-transform hover:scale-110"
                />
            </button>

            <button
                onClick={() => {
                    const EXT_ID = process.env.REACT_APP_MSP_EXTENSION_ID || 'elebkaoefjdagkbfienaoonkgifogkob';
                    if (window.chrome?.runtime?.sendMessage && EXT_ID) {
                        window.chrome.runtime.sendMessage(EXT_ID, {
                            type: 'MSP_SEARCH_INTENT',
                            marketplace: deal.marketplace,
                            identifier: identifier,
                            title: deal.title,
                            deal,
                        });
                    }
                    window.open(`https://www.google.com/search?q=${encodeURIComponent(deal.title)}&gl=us&hl=en&cr=countryUS`);
                }}
                className="rounded-full p-1 text-gray-400 hover:bg-gray-100 transition-all"
                title="Search on Google"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg"
                    alt="Google"
                    style={{ width: '18px', height: '18px', objectFit: 'contain' }}
                />
            </button>
        </>
    );
};

export default UniversalFavoriteButton;